<template>
  <div v-if="event.title">
    <div class="text-xs-center pb-3">
      <img :src="imageUrl" alt="Logo" style="max-height: 300px; max-width: 80%">
    </div>
    <v-layout align-center justify-center wrap class="mb-4">
      <v-flex xs12 sm8>
        <h2>{{ event.title }}</h2>
        <p v-html="event.description"></p>
        Veranstaltungsdatum: {{ event.date | stringToDate }}<br />
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center wrap class="mt-4" v-if="event.capacityLeft <= 0">
      <v-flex xs12 sm8>
        Alle Plätze sind bereits vergeben.
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center wrap class="mt-4" v-else-if="guest.status === 0">
      <v-flex xs12 sm8>
        <v-layout wrap>
          <v-flex xs6 class="text-xs-center">
            <v-btn
              color="error"
              @click="deny"
              :loading="loading"
            >
              Ablehnen
            </v-btn>
          </v-flex>
          <v-flex xs6 class="text-xs-center">
            <v-menu offset-y>
              <v-btn
                slot="activator"
                :color="acceptButtonStyle.color"
                :style="acceptButtonStyle.style"
                dark
                :loading="loading"
              >
                Annehmen
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="(item, index) in items"
                  :key="index"
                  @click="accept(index)"
                >
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center wrap class="mt-4" v-else-if="guest.status === 70">
      <v-flex xs12 sm8>
        Sie haben sich erfolgreich angemeldet.
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center wrap class="mt-4" v-else-if="guest.status === 99">
      <v-flex xs12 sm8>
        Sie haben erfolgreich abgelehnt.
      </v-flex>
    </v-layout>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<script>
import { Storage } from 'aws-amplify';
import { mapActions, mapGetters } from 'vuex';

export default {
  props: ['eventId', 'guestId'],
  data() {
    return {
      items: [
        {title: 'Ohne Begleitpersonen'},
        {title: '1 Begleitperson'},
        {title: '2 Begleitpersonen'},
        {title: '3 Begleitpersonen'},
      ],
      imageUrl: '',
      loading: false,
      select: null,
      checkbox: false,
    };
  },
  computed: {
    ...mapGetters({
      event: 'pub/eventGuest/event',
      guest: 'pub/eventGuest/guest',
    }),
    acceptButtonStyle() {
      if (this.event.companyId === '9f11368c-6e6d-4b5f-b0e5-121a789a0893') {
        return {
          color: '',
          style: 'background-color: #47E0C2; color: #184857;',
        };
      }
      return { color: 'primary', style: '' };
    },
  },
  methods: {
    ...mapActions({
      readEvent: 'pub/eventGuest/read',
      storeAccept: 'pub/eventGuest/accept',
      storeDeny: 'pub/eventGuest/deny',
      startLoader: 'common/loader/start',
      stopLoader: 'common/loader/stop',
    }),
    accept(count) {
      this.loading = true;
      this.storeAccept({eventId: this.eventId, guestId: this.guestId, companions: count})
        .then(() => this.readEvent({guestId: this.guestId, eventId: this.eventId}))
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    deny() {
      this.loading = true;
      this.storeDeny({eventId: this.eventId, guestId: this.guestId})
        .then(() => this.readEvent({guestId: this.guestId, eventId: this.eventId}))
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  async mounted() {
    this.startLoader();
    await this.readEvent({guestId: this.guestId, eventId: this.eventId});

    if (this.event.capacityLeft) {
      this.items = this.items.slice(0, Math.min(this.event.capacityLeft, 4));
    }


    this.imageUrl = await Storage.get(this.event.logo);
    this.stopLoader();
  },
};
</script>
